import IconPlus from "./icon-plus";
export default IconPlus;